<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Tên" prop="name">
        <a-input v-model="form.name" placeholder="Nhập tên" />
      </a-form-model-item>

      <a-form-model-item label="Người dùng" prop="userIds">
        <SelectUser
          v-model="form.userIds"
          :selectProps="{
            value: form.userIds,
            placeholder: 'Chọn người dùng',
            mode: 'multiple',
          }"
          :variablesQuery="{
            hasEmployee: false,
          }"
        />
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="closeDrawerAdd" style="margin-right: 5px;" icon="close">
        Đóng
      </a-button>
      <a-button
        type="primary"
        @click="create()"
        :loading="iconLoading"
        icon="plus"
      >
        Thêm mới
      </a-button>
    </div>
  </div>
</template>
<script>
import queryItem from "../data/queryItem";
import SelectUser from "@/components/common/user/select";
export default {
  components: {
    SelectUser,
  },
  props: {
    closeDrawerAdd: {
      type: Function,
      default: null,
    },
    createdOnView: {
      type: Function,
    },
  },
  data() {
    return {
      iconLoading: false,
      form: {
        name: undefined,
        userIds: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: "Tên không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    create() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.iconLoading = true;
          console.log(this.form);
          this.$apollo
            .mutate({
              mutation: queryItem.queryCreate,
              variables: {
                ...this.form,
              },
            })
            .then(({ data }) => {
              if (data?.createRole) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Thêm thành công !",
                });
                   this.closeDrawerAdd();
                this.createdOnView(data.createRole);
              }
              this.iconLoading = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Thông báo",
                description: "Thêm không thành công !" + error,
              });
              this.iconLoading = false;
            });
        }
      });
    },
  },
};
</script>
<style></style>
